// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"3e36013e","868":"b1a8cbca"}[chunkId] + ".chunk.js";
};